const ENTER_KEY_CODE = 13;

export default ENTER_KEY_CODE;

export const EVENT_KEY = {
  ENTER: 'Enter',
  SPACE: ' ',
};
